import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CampaignMilestone, ProjectSection, ProjectStatusList, ProjectSubsection } from '../../interfaces';

export type SectionStatusSource = ProjectSection | ProjectSubsection | null;
export type GeneralStatusSource = SectionStatusSource | CampaignMilestone;

export function isStatusSourceSubsection(source: SectionStatusSource): source is ProjectSubsection {
  return source && (source as ProjectSubsection).subSection != null;
}

@Component({
  selector: 'mtm-status-flag-milestone',
  templateUrl: './status-flag-milestone.component.html',
  standalone: false,
})
export class StatusFlagMilestoneComponent implements OnChanges {
  flagBgColor: string = '#555';
  flagFillColor: string = '#fff';
  _source: GeneralStatusSource = null;
  _status: string = ProjectStatusList.TO_COME;

  @Output() statusClick: EventEmitter<GeneralStatusSource> = new EventEmitter<GeneralStatusSource>();

  @Input()
  isTransparentBg: boolean = false;

  @Input()
  flagWidth: number = 17;

  @Input()
  flagHeight: number = 17;

  get status(): string {
    return this._status;
  }

  @Input()
  set status(value: string) {
    this._status = value;
    this.adjustStatus();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isTransparentBg'] && !changes['isTransparentBg'].firstChange) {
      this.adjustStatus();
    }
  }

  get viewBox(): string {
    return `0 0 17 17`;
  }

  get source() {
    return this._source;
  }

  @Input()
  set source(value: GeneralStatusSource) {
    this._source = value;
    if (!this.source) {
      return;
    }
    this._status = this.source.status;
    this.adjustStatus();
  }

  private adjustStatus() {
    switch (this.status) {
      case ProjectStatusList.IN_PROGRESS:
        this.flagBgColor = this.isTransparentBg ? 'white' : '#4a90e2';
        this.flagFillColor = this.isTransparentBg ? 'black' : '#fff';
        break;
      case ProjectStatusList.UPCOMING_EXPIRY:
      case ProjectStatusList.BEWARE:
        this.flagBgColor = this.isTransparentBg ? '#fff' : '#f77f40';
        this.flagFillColor = this.isTransparentBg ? '#f77f40' : '#fff';
        break;
      case ProjectStatusList.DELAYED:
        this.flagBgColor = this.isTransparentBg ? '#fff' : '#f76769';
        this.flagFillColor = this.isTransparentBg ? '#f76769' : '#fff';
        break;
      case ProjectStatusList.COMPLETED:
        this.flagBgColor = this.isTransparentBg ? '#fff' : '#43CB9A';
        this.flagFillColor = this.isTransparentBg ? '#43CB9A' : '#fff';
        break;

      case ProjectStatusList.TO_COME:
      default:
        this.flagBgColor = '#555';
        this.flagFillColor = this.isTransparentBg ? '#555' : '#fff';
        break;
    }
  }

  triggerStatusClick() {
    this.statusClick.emit(this.source);
  }
}
